import { render } from "./FForm.vue?vue&type=template&id=26cffcbc"
import script from "./FForm.vue?vue&type=script&lang=js"
export * from "./FForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__